<div class="spinner-ball-styles" [ngClass]="spinnerStyles">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
